<template>
	<div class="modal-container">
		<div class="modal">
			<p>
				{{ $t('deactivatePlantingFirstPart') }} <strong>{{ disabled_item }}</strong> ?
				{{ $t('deactivatePlantingSecondPart') }}
			</p>
			<div class="input">
				<InputText
					v-model="email"
					:placeholder="$t('deactivate_placeholder')"
					@input="validateEmail"
				/>
			</div>
			<div class="container__crud__crudform__buttons">
				<a
					style="color: red"
					@click="handleDeactivateClick"
					>{{ $t('desactivate') }}</a
				>
				<a
					style="color: blue"
					@click="$emit('cancelar_desativacao')"
					>{{ $t('cancel_desactivate') }}</a
				>
			</div>
			<slot />
		</div>
	</div>
</template>

<script>
import InputText from '../../components/InputText/InputText.vue'

export default {
	name: 'ModalConfirmPlantio',
	components: {
		InputText,
	},
	props: {
		disabled_item: {
			type: String,
			required: true,
		},
		item_type: {
			type: String,
			required: true,
		},
	},

	data() {
		return {
			email: '',
			isEmailValid: false,
		}
	},

	watch: {
		email(newEmail) {
			this.validateEmail(newEmail)
		},
	},

	methods: {
		validateEmail(email) {
			const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
			this.isEmailValid = emailPattern.test(email)
		},

		handleDeactivateClick() {
			if (this.isEmailValid) {
				this.$emit('desativar_registro')
			} else {
				alert(this.$t('insert_valid_email'))
			}
		},
	},
}
</script>

<style scoped>
.modal-container {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgba(0, 0, 0, 0.5); /* Fundo escuro para destacar a modal */
}

.modal {
	background-color: white;
	padding: 20px;
	border-radius: 8px;
	width: 400px;
	height: 300px;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.container__crud__crudform__buttons {
	display: flex;
	justify-content: center;
	gap: 150px;
	margin-top: 20px;
}
.p {
	color: #737576;
}
</style>
